module.exports = __webpack_public_path__ + "static/media/ic-exit.b09cfc31.svg";